// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Above SlidePanel (backdrop 1054, panel 1055) so the calendar is not hidden behind it. */
.expense-datepicker-popper {
  z-index: 2000 !important;
}

.expense-datepicker-input {
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
}

.expense-datepicker-input.is-compact {
  height: 38px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ExpenseManagement/ExpenseDatePicker.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* Above SlidePanel (backdrop 1054, panel 1055) so the calendar is not hidden behind it. */\n.expense-datepicker-popper {\n  z-index: 2000 !important;\n}\n\n.expense-datepicker-input {\n  height: 40px;\n  font-size: 14px;\n  border-radius: 6px;\n}\n\n.expense-datepicker-input.is-compact {\n  height: 38px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
